import Vue from 'vue';

export default {
    consultarISN(parametros) {
        return Vue.axios.post("reportes/impuesto-sobre-nomina", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    findAnios(parametros) {
        return Vue.axios.get("anio-fiscal/find", { params: parametros }).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
}